import {ValueObject} from '@s-ui/domain'

export class CarouselsInfoValueObject extends ValueObject {
  /**
   * @param {Array<CarouselInfoValueObject>} carousels
   * */
}
